import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

const LEVEL_VARIANTS = {
  beginner: 'beg',
  intermediate: 'int',
  advanced: 'adv',
  professional: 'pro',
  beg: 'beg',
  int: 'int',
  adv: 'adv',
  pro: 'pro',
};

export default function SkillLevelChip({ level, children, className = '' }) {
  const variant = LEVEL_VARIANTS[String(level || '').toLowerCase()] || 'beg';
  const classes = ['skill-level-chip', `skill-level-chip--${variant}`, className].filter(Boolean).join(' ');
  return <span className={classes}>{children || level}</span>;
}

SkillLevelChip.propTypes = {
  level: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
};
